import { render, staticRenderFns } from "./LiveAuctionPage.vue?vue&type=template&id=548d4be4&scoped=true&"
import script from "./LiveAuctionPage.vue?vue&type=script&lang=js&"
export * from "./LiveAuctionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d4be4",
  null
  
)

export default component.exports